import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router';

import useAsyncEffect from 'use-async-effect';

import { useFirstWorkspace } from '@anyx/common-workspace';
import { LoadWrapper, Title } from '@anyx/shared-ui';
import { AsyncOperationState } from '@anyx/shared-utils';

export const OnboardingTemplate = () => {
  const navigate = useNavigate();

  const { getFirstWorkspace } = useFirstWorkspace();

  const [status, setStatus] = useState<AsyncOperationState>(AsyncOperationState.IDLE);
  useAsyncEffect(
    async (isMounted) => {
      setStatus(AsyncOperationState.LOADING);
      try {
        const workspace = await getFirstWorkspace();
        setStatus(AsyncOperationState.SUCCESS);

        if (!isMounted()) return;

        if (workspace) {
          navigate('/');
        }
      } catch {
        setStatus(AsyncOperationState.ERROR);
        if (!isMounted()) return;
        navigate('/error/unavailable');
      }
    },
    [getFirstWorkspace, navigate]
  );

  return (
    <div className="w-full">
      <Title />
      <LoadWrapper
        loading={status === AsyncOperationState.LOADING}
        message="This is Onboarding Template loader"
      >
        <Outlet />
      </LoadWrapper>
    </div>
  );
};
